import DialogName from '../constants/DialogName';
import hideDialog from './hideDialog';

export default function hideEditFeatureWorksheet() {
  return hideDialog(DialogName.EDIT_FEATURE_WORKSHEET)();
}
